export class Certificationdocument {

  userId: number;
  path: string;
  name: string;
  validaty: string;
  auditedBy: any;
  validated: any;


  constructor() {
    this.userId = null;
    this.path = null;
    this.name = null;
    this.validaty = null;
    this.auditedBy = null;
    this.validated = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/certificationdocument.ts